var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { enableDisableToolbarItems, updateSelectAllCheckbox } from './organize-toolbar';
import { disableTileDeleteButton, updateTempRotationDetail } from './tile-interaction';
import { getNextSubIndex } from './organize-math-utils';
import { clonedCollection } from './organize-undoredoutils';
import { updatePageNumber, updateTotalPageCount } from './organize-initialization';
import { copyPage } from './organize-utils';
import { inputTextboxUpdate } from './organize-extract';
/**
 * @private
 * @param {any} event - It's describe about event.
 * @returns { void }
 */
export function pageDragDrop(event) {
    var mainTileElement = event.target.closest('.e-pv-organize-anchor-node');
    var pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
    this.dragEndIndex = pageOrder;
    movePDFpages.call(this, this.selectedPageIndexes, this.dragEndIndex, this.isRightInsertion);
}
/**
 * @private
 * @param {number[]} selectedPagesIndexes - It's describe about selected pages indexes.
 * @param {number} dropIndex - It's describe about droped pages index.
 * @param {boolean} isRightInsertion - It's describe about insert page right side or not.
 * @returns { void }
 */
export function movePDFpages(selectedPagesIndexes, dropIndex, isRightInsertion) {
    var _this = this;
    // Checking if the dropIndex is equal to any of the selected pages indexes
    var isDropIndexSelected = false;
    for (var _i = 0, selectedPagesIndexes_1 = selectedPagesIndexes; _i < selectedPagesIndexes_1.length; _i++) {
        var index = selectedPagesIndexes_1[_i];
        if (index === dropIndex) {
            isDropIndexSelected = true;
            break;
        }
    }
    // If the dropIndex is one of the selected pages, return early
    if (isDropIndexSelected) {
        return;
    }
    var clonedCollections = [];
    var _loop_1 = function (i) {
        clonedCollections.push(clonedCollection.call(this_1, this_1.tempOrganizePagesCollection.
            find(function (item) {
            return item.currentPageIndex ===
                _this.selectedPageIndexes[parseInt(i.toString(), 10)];
        })));
    };
    var this_1 = this;
    for (var i = 0; i < this.selectedPageIndexes.length; i++) {
        _loop_1(i);
    }
    var cloneSelectedIndexes = [];
    cloneSelectedIndexes.push.apply(cloneSelectedIndexes, this.selectedPageIndexes);
    this.addOrganizeAction(clonedCollections, 'Move Pages', [], cloneSelectedIndexes, this.dragEndIndex, this.isRightInsertion);
    rearrangePages.call(this, selectedPagesIndexes, dropIndex, isRightInsertion);
}
/**
 * @private
 * @param {number[]} selectedPagesIndexes - It's describe about selected pages indexes.
 * @param {number} dropIndex - It's describe about droped pages index.
 * @param {boolean} isRightInsertion - It's describe about insert page right side or not.
 * @returns { void }
 */
export function rearrangePages(selectedPagesIndexes, dropIndex, isRightInsertion) {
    // eslint-disable-next-line
    var proxy = this;
    this.tempOrganizePagesCollection =
        updateCollection.call(this, this.tempOrganizePagesCollection, selectedPagesIndexes, dropIndex, isRightInsertion);
    var pages = Array.from(this.tileAreaDiv.children);
    selectedPagesIndexes.sort(function (a, b) { return a - b; });
    var draggedElements = selectedPagesIndexes.map(function (index) { return pages[parseInt(index.toString(), 10)]; });
    var adjustedDropIndex = isRightInsertion ? dropIndex + 1 : dropIndex;
    draggedElements.forEach(function (element) {
        pages.splice(adjustedDropIndex, 0, element);
        adjustedDropIndex += 1;
    });
    for (var i = 0; i < selectedPagesIndexes.length; i++) {
        if (selectedPagesIndexes[parseInt(i.toString(), 10)] >= dropIndex) {
            selectedPagesIndexes[parseInt(i.toString(), 10)] += draggedElements.length;
        }
    }
    selectedPagesIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        pages.splice(index, 1);
    });
    this.tileAreaDiv.innerHTML = '';
    pages.forEach(function (page, index) {
        proxy.tileAreaDiv.appendChild(page);
        page.setAttribute('data-page-order', index.toString());
    });
    updatePageNumber.call(this);
    if (this.isExtractToolbarVisible) {
        inputTextboxUpdate.call(this);
    }
}
/**
 * @private
 * @param {OrganizeDetails[]} collection - It's describe about organize page action collection.
 * @param {number[]} selectedIndexes - It's describe about selected pages indexes.
 * @param {number} dropIndex - It's describe about droped pages index.
 * @param {boolean} isRightInsertion - It's describe about insert page right side or not.
 * @returns { OrganizeDetails[] } - It's describe about organize page updated collection.
 */
export function updateCollection(collection, selectedIndexes, dropIndex, isRightInsertion) {
    var _this = this;
    var collectionCopy = [];
    var index = 0;
    var isAlreadyAdded = [];
    selectedIndexes.sort();
    dropIndex = isRightInsertion ? dropIndex + 1 : dropIndex;
    var selectedIndexesUnderDropIndexCount = 0;
    selectedIndexes.forEach(function (index) {
        if (index < dropIndex) {
            selectedIndexesUnderDropIndexCount++;
        }
    });
    var sortedCollection = collection.sort(function (a, b) { return _this.sorting(a['currentPageIndex'], b['currentPageIndex']); });
    var nullCurrentPageIndexCount = sortedCollection.filter(function (item) { return item.currentPageIndex === null; }).length;
    sortedCollection.forEach(function (item) {
        if (item.currentPageIndex === null) {
            collectionCopy.push(__assign({}, item));
        }
    });
    //Updated currentPageIndex for the pages before drop index
    for (var i = 0; i < sortedCollection.length; i++) {
        // checking the given Currentpageindex exists in the selected indexes
        var isCurrentPageIndexInSelectedIndexes = false;
        for (var j = 0; j < selectedIndexes.length; j++) {
            if (sortedCollection[parseInt(i.toString(), 10)].currentPageIndex === selectedIndexes[parseInt(j.toString(), 10)]) {
                isCurrentPageIndexInSelectedIndexes = true;
                break;
            }
        }
        if (index === dropIndex - selectedIndexesUnderDropIndexCount) {
            break;
        }
        if (!isCurrentPageIndexInSelectedIndexes &&
            !containsPageDetails(sortedCollection[parseInt(i.toString(), 10)], isAlreadyAdded)) {
            if (!isNullOrUndefined(sortedCollection[parseInt(i.toString(), 10)].currentPageIndex)) {
                collectionCopy.push(__assign({}, sortedCollection[parseInt(i.toString(), 10)]));
                isAlreadyAdded.push(sortedCollection[parseInt(i.toString(), 10)]);
                collectionCopy[collectionCopy.length - 1].currentPageIndex = index;
                index = index + 1;
            }
        }
    }
    //Updated currentPageIndex for the selected pages in the drop index
    for (var i = 0; i < sortedCollection.length; i++) {
        var isCurrentPageIndexInSelectedIndexes = false;
        for (var j = 0; j < selectedIndexes.length; j++) {
            if (sortedCollection[parseInt(i.toString(), 10)].currentPageIndex === selectedIndexes[parseInt(j.toString(), 10)]) {
                isCurrentPageIndexInSelectedIndexes = true;
                break;
            }
        }
        if (isCurrentPageIndexInSelectedIndexes &&
            !containsPageDetails(sortedCollection[parseInt(i.toString(), 10)], isAlreadyAdded)) {
            collectionCopy.push(__assign({}, sortedCollection[parseInt(i.toString(), 10)]));
            isAlreadyAdded.push(sortedCollection[parseInt(i.toString(), 10)]);
            collectionCopy[collectionCopy.length - 1].currentPageIndex = index;
            index = index + 1;
        }
    }
    //Updated currentPageIndex for the pages after drop index
    for (var i = nullCurrentPageIndexCount; i < sortedCollection.length; i++) {
        // checking the given Currentpageindex exists in the selected indexes
        var isCurrentPageIndexInSelectedIndexes = false;
        for (var j = 0; j < selectedIndexes.length; j++) {
            if (sortedCollection[parseInt(i.toString(), 10)].currentPageIndex === selectedIndexes[parseInt(j.toString(), 10)]) {
                isCurrentPageIndexInSelectedIndexes = true;
                break;
            }
        }
        if (!isCurrentPageIndexInSelectedIndexes &&
            !containsPageDetails(sortedCollection[parseInt(i.toString(), 10)], isAlreadyAdded)) {
            collectionCopy.push(__assign({}, sortedCollection[parseInt(i.toString(), 10)]));
            isAlreadyAdded.push(sortedCollection[parseInt(i.toString(), 10)]);
            collectionCopy[collectionCopy.length - 1].currentPageIndex = index;
            index = index + 1;
        }
    }
    return collectionCopy;
}
/**
 * @private
 * @param {OrganizeDetails} value - It's describe about organize page details.
 * @param {OrganizeDetails[]} array - It's describe about selected pages indexes.
 * @returns { void }
 */
export function containsPageDetails(value, array) {
    var pageIndexFound = false;
    var currentPageIndexFound = false;
    for (var i = 0; i < array.length; i++) {
        if (array[parseInt(i.toString(), 10)].pageIndex === value.pageIndex) {
            pageIndexFound = true;
        }
        if (array[parseInt(i.toString(), 10)].currentPageIndex === value.currentPageIndex) {
            currentPageIndexFound = true;
        }
    }
    return pageIndexFound && currentPageIndexFound;
}
/**
 * @private
 * @param {MouseEvent} event - It's describe about event.
 * @returns { void }
 */
export function rotateButtonClick(event) {
    if (this.pdfViewer.pageOrganizerSettings.canRotate) {
        var rotateButton = event.currentTarget;
        var mainTileElement = rotateButton.closest('.e-pv-organize-anchor-node');
        var imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
        var pageOrder_1 = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
        if (imageContainer) {
            // Get the current rotation angle of the image container (if any)
            var currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
            // Calculate the new rotation angle (add 90 degrees)
            currentRotation += 90;
            // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
            if (currentRotation >= 360) {
                currentRotation = 0;
            }
            // Apply the rotation to the image container
            imageContainer.style.transform = "rotate(" + currentRotation + "deg)";
            // Update the rotation value in the pageDetails collection
            updateTempRotationDetail.call(this, pageOrder_1, 90);
            var clonedCollections = [];
            clonedCollections.push(clonedCollection.call(this, this.tempOrganizePagesCollection.
                find(function (item) { return item.currentPageIndex === pageOrder_1; })));
            this.addOrganizeAction(clonedCollections, 'Rotate Right', [], [], null, false);
        }
    }
}
/**
 * @private
 * @param {MouseEvent} event - It's describe about event.
 * @returns { void }
 */
export function rotateLeftButtonClick(event) {
    if (this.pdfViewer.pageOrganizerSettings.canRotate) {
        var rotateButton = event.currentTarget;
        var mainTileElement = rotateButton.closest('.e-pv-organize-anchor-node');
        var imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
        var pageOrder_2 = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
        if (imageContainer) {
            // Get the current rotation angle of the image container (if any)
            var currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
            // Calculate the new rotation angle (add 90 degrees)
            currentRotation -= 90;
            // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
            if (currentRotation >= 360) {
                currentRotation = 0;
            }
            if (currentRotation === -90) {
                currentRotation = 270;
            }
            // Apply the rotation to the image container
            imageContainer.style.transform = "rotate(" + currentRotation + "deg)";
            // Update the rotation value in the pageDetails collection
            updateTempRotationDetail.call(this, pageOrder_2, -90);
            var clonedCollections = [];
            clonedCollections.push(clonedCollection.call(this, this.tempOrganizePagesCollection.
                find(function (item) { return item.currentPageIndex === pageOrder_2; })));
            this.addOrganizeAction(clonedCollections, 'Rotate Left', [], [], null, false);
        }
    }
}
/**
 * @private
 * @returns { void }
 */
export function onToolbarRightButtonClick() {
    if (this.pdfViewer.pageOrganizerSettings.canRotate) {
        // eslint-disable-next-line
        var proxy = this;
        var _loop_2 = function (i) {
            var mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
            // Type assertion to HTMLElement
            if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
                var imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
                var pageOrder_3 = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                if (imageContainer) {
                    // Get the current rotation angle of the image container (if any)
                    var currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                    // Calculate the new rotation angle (add 90 degrees)
                    currentRotation += 90;
                    // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
                    if (currentRotation >= 360) {
                        currentRotation = 0;
                    }
                    // Apply the rotation to the image container
                    imageContainer.style.transform = "rotate(" + currentRotation + "deg)";
                    // Update the rotation value in the pageDetails collection
                    updateTempRotationDetail.call(this_2, pageOrder_3, 90);
                    this_2.toolbarUndoRedoCollection.
                        push(clonedCollection.call(this_2, this_2.tempOrganizePagesCollection.
                        find(function (item) { return item.currentPageIndex === pageOrder_3; })));
                }
            }
        };
        var this_2 = this;
        for (var i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
            _loop_2(i);
        }
        this.addOrganizeAction(null, 'Toolbar Rotate Right', this.toolbarUndoRedoCollection, [], null, false);
        this.toolbarUndoRedoCollection = [];
    }
}
/**
 * @private
 * @returns { void }
 */
export function onToolbarLeftButtonClick() {
    // eslint-disable-next-line
    var proxy = this;
    var _loop_3 = function (i) {
        var mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
        // Type assertion to HTMLElement
        if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
            var imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
            var pageOrder_4 = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
            if (imageContainer) {
                // Get the current rotation angle of the image container (if any)
                var currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                // Calculate the new rotation angle (add 90 degrees)
                currentRotation -= 90;
                // Ensure that the rotation stays within the desired range (0, 90, 180, 270, 360)
                if (currentRotation >= 360) {
                    currentRotation = 0;
                }
                if (currentRotation === -90) {
                    currentRotation = 270;
                }
                // Apply the rotation to the image container
                imageContainer.style.transform = "rotate(" + currentRotation + "deg)";
                // Update the rotation value in the pageDetails collection
                updateTempRotationDetail.call(this_3, pageOrder_4, -90);
                this_3.toolbarUndoRedoCollection.
                    push(clonedCollection.call(this_3, this_3.tempOrganizePagesCollection.
                    find(function (item) { return item.currentPageIndex === pageOrder_4; })));
            }
        }
    };
    var this_3 = this;
    for (var i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
        _loop_3(i);
    }
    this.addOrganizeAction(null, 'Toolbar Rotate Left', this.toolbarUndoRedoCollection, [], null, false);
    this.toolbarUndoRedoCollection = [];
}
/**
 * @private
 * @returns { void }
 */
export function onToolbarCopyButtonClick() {
    if (this.pdfViewer.pageOrganizerSettings.canCopy) {
        // eslint-disable-next-line
        var proxy = this;
        var _loop_4 = function (i) {
            var mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
            if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
                var pageId = mainTileElement.id.split('anchor_page_')[mainTileElement.id.split('anchor_page_').length - 1];
                var pageOrder_5 = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                var pageIdlist = pageId.split('_');
                var subIndex = 0;
                var pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 1).toString(), 10)], 10);
                if (pageIdlist.length > 1) {
                    pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 2).toString(), 10)], 10);
                }
                subIndex = getNextSubIndex.call(this_4, mainTileElement.parentElement, pageIndex);
                copyPage.call(this_4, pageOrder_5, mainTileElement);
                this_4.tileImageRender(pageIndex, subIndex, pageOrder_5 + 1, mainTileElement, true, false, false);
                updatePageNumber.call(this_4);
                this_4.toolbarUndoRedoCollection.
                    push(clonedCollection.call(this_4, this_4.tempOrganizePagesCollection.
                    find(function (item) { return item.currentPageIndex === (pageOrder_5 + 1); })));
            }
        };
        var this_4 = this;
        for (var i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
            _loop_4(i);
        }
        updateTotalPageCount.call(this);
        if (this.isExtractToolbarVisible) {
            inputTextboxUpdate.call(this);
        }
        disableTileDeleteButton.call(this);
        updateSelectAllCheckbox.call(this);
        enableDisableToolbarItems.call(this);
        this.addOrganizeAction(null, 'Toolbar Copy', this.toolbarUndoRedoCollection, [], null, false);
        this.toolbarUndoRedoCollection = [];
    }
}
/**
 * @private
 * @returns { void }
 */
export function onToolbarDeleteButtonClick() {
    var _this = this;
    if (this.pdfViewer.pageOrganizerSettings.canDelete) {
        // eslint-disable-next-line
        var proxy_1 = this;
        var selectedNodes = proxy_1.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring');
        selectedNodes.forEach(function (selectedElements) {
            var mainTileElement = selectedElements.closest('.e-pv-organize-anchor-node');
            var pageOrder = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
            _this.toolbarUndoRedoCollection.
                push(clonedCollection.call(_this, _this.tempOrganizePagesCollection.
                find(function (item) { return item.currentPageIndex === pageOrder; })));
        });
        selectedNodes.forEach(function (selectedElement) {
            var mainTileElement = selectedElement.closest('.e-pv-organize-anchor-node');
            proxy_1.deletePageElement(mainTileElement);
        });
    }
    // If extract toolbar is visible, clear its input and disable the footer extract button
    if (this.isExtractToolbarVisible) {
        if (this.extractPagesInput) {
            this.extractPagesInput.value = '';
        }
        var extractBtn = document.getElementsByClassName('e-pv-extractbtn')[0];
        if (extractBtn) {
            extractBtn.disabled = true;
        }
    }
    enableDisableToolbarItems.call(this);
    this.addOrganizeAction(null, 'Toolbar Delete', this.toolbarUndoRedoCollection, [], null, false);
    this.toolbarUndoRedoCollection = [];
}
